import { render, staticRenderFns } from "./StockTotalChange.vue?vue&type=template&id=dcfa9424&scoped=true&"
import script from "./StockTotalChange.vue?vue&type=script&lang=js&"
export * from "./StockTotalChange.vue?vue&type=script&lang=js&"
import style0 from "./StockTotalChange.vue?vue&type=style&index=0&id=dcfa9424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfa9424",
  null
  
)

export default component.exports